// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"UserItem_menuItem__kqhYp","menuItemText":"UserItem_menuItemText__nAp5e","menuItemTextActive":"UserItem_menuItemTextActive__jrHJv","user":"UserItem_user__1noZ6"};